// components/Portfolio.js
import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';

function Portfolio() {
  return (
    <section id="portfolio" className="py-5 bg-light">
      <Container>
        <h2 className="text-center mb-5">Our Portfolio</h2>
        <Row>
          <Col md={4} className="mb-4">
            <Card>
              <Card.Img variant="top" src="https://cdn.dribbble.com/userupload/10759350/file/original-a7a6c5a670d873c27c6b526b13a6fee3.png?resize=1504x1128" />
              <Card.Body>
                <Card.Title>Real estate App</Card.Title>
                <Card.Text>Best in class for room booking.</Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4} className="mb-4">
            <Card>
              <Card.Img variant="top" src="https://cdn.dribbble.com/userupload/15605856/file/original-b726af759a944a0a5bb5b400c55675c0.png?resize=752x" />
              <Card.Body>
                <Card.Title>Music Streaming App</Card.Title>
                <Card.Text>Best in class music streaming app.</Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4} className="mb-4">
            <Card>
              <Card.Img variant="top" src="https://cdn.dribbble.com/userupload/15719733/file/original-b4bb7094443361dd3d78c0b13df99e77.png?resize=1504x1128&vertical=center" />
              <Card.Body>
                <Card.Title>Social media app.</Card.Title>
                <Card.Text>Best in class social media app.</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Portfolio;